import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const originalPush = Router.prototype.push
    //修改原型对象中的push方法
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
    routes: [{
        path: '/',
        redirect: '/index/home',
    }, {
        path: '/index',
        component: () =>
            import ('@/views/Home/index'),
        meta: {
            title: '前端导航模板'
        },
        children: [{
                path: 'home',
                component: () =>
                    import ('@/views/MassHome/index'),
                meta: {
                    title: '微商进销存管理PC版'
                }
            },
            {
                path: 'outstocks',
                component: () =>
                    import ('@/views/MassHome/outstocks'),
                meta: {
                    title: '商品出库'
                }
            },
            {
                path: 'customer',
                component: () =>
                    import ('@/views/MassHome/customer'),
                meta: {
                    title: '顾客管理'
                }
            },
            {
                path: 'goodlist',
                component: () =>
                    import ('@/views/MassHome/goodlist'),
                meta: {
                    title: '商品管理'
                }
            },
            {
                path: 'textsec',
                component: () =>
                    import ('@/views/MassHome/textsec'),
                meta: {
                    title: '出库列表'
                }
            },
            {
                path: 'outstocksdraft',
                component: () =>
                    import ('@/views/MassHome/outstocksdraft'),
                meta: {
                    title: '销售计划'
                }
            }, {
                path: 'supplylist',
                component: () =>
                    import ('@/views/MassHome/supplylist'),
                meta: {
                    title: '供应商管理'
                }
            }, {
                path: 'instocklist',
                component: () =>
                    import ('@/views/MassHome/instocklist'),
                meta: {
                    title: '商品入库'
                }
            }, {
                path: 'outstocksreturn',
                component: () =>
                    import ('@/views/MassHome/outstocksreturn'),
                meta: {
                    title: '出库退货'
                }
            }, {
                path: 'instocksreturn',
                component: () =>
                    import ('@/views/MassHome/instocksreturn'),
                meta: {
                    title: '入库退货'
                }
            }, {
                path: 'outstatics',
                component: () =>
                    import ('@/views/MassHome/outstatics'),
                meta: {
                    title: '库存盘点'
                }
            }, {
                path: 'outwarn',
                component: () =>
                    import ('@/views/MassHome/outwarn'),
                meta: {
                    title: '库存预警'
                }
            }, {
                path: 'purchasingplan',
                component: () =>
                    import ('@/views/MassHome/purchasingplan'),
                meta: {
                    title: '采购计划'
                }
            }, {
                path: 'systemsetting',
                name: 'systemsetting',
                component: () =>
                    import ('@/views/MassHome/systemsetting'),
                meta: {
                    title: '系统设置'
                }
            }, {
                path: 'systemsettingsub/recyclebin',
                name: 'recyclebin',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/recyclebin'),
                meta: {
                    title: '回收站'
                }
            }, {
                path: 'systemsettingsub/operationlog',
                name: 'operationlog',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/operationlog'),
                meta: {
                    title: '操作日志'
                }
            }, {
                path: 'systemsettingsub/updatelog',
                name: 'updatelog',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/updatelog'),
                meta: {
                    title: '更新日志'
                }
            }, {
                path: 'systemsettingsub/individualcenter',
                name: 'individualcenter',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/individualcenter'),
                meta: {
                    title: '个人中心'
                }
            }, {
                path: 'systemsettingsub',
                name: 'systemsettingsub',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub'),
                meta: {
                    title: '二级设置'
                }
            }, {
                path: 'statement',
                name: 'statement',
                component: () =>
                    import ('@/views/MassHome/statement'),
                meta: {
                    title: '统计报表'
                }
            }, {
                path: 'productcategory',
                name: 'productcategory',
                component: () =>
                    import ('@/views/MassHome/productcategory'),
                meta: {
                    title: '商品类别'
                }
            }, {
                path: 'systemsettingsub/spectemplate',
                name: 'spectemplate',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/spectemplate'),
                meta: {
                    title: '多规格模板'
                }
            }, {
                path: 'systemsettingsub/inportandexportmenu',
                name: 'inportandexportmenu',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/inportandexportmenu'),
                meta: {
                    title: '导入导出数据'
                }
            }, {
                path: 'systemsettingsub/batchmodgoodmenu',
                name: 'batchmodgoodmenu',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/batchmodgoodmenu'),
                meta: {
                    title: '批量修改商品'
                }
            },  {
                path: 'systemsettingsub/renewalrecord',
                name: 'renewalrecord',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/renewalrecord'),
                meta: {
                    title: '续费记录'
                }
            },{
                path: 'systemsettingsub/inportandexportsub/inportgoods',
                name: 'inportgoods',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/inportandexportsub/inportgoods'),
                meta: {
                    title: '导入商品数据'
                }
            }, {
                path: 'systemsettingsub/inportandexportsub/exportgoods',
                name: 'exportgoods',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/inportandexportsub/exportgoods'),
                meta: {
                    title: '导出商品数据'
                }
            }, {
                path: 'systemsettingsub/inportandexportsub/inportcustomer',
                name: 'inportcustomer',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/inportandexportsub/inportcustomer'),
                meta: {
                    title: '导入客户数据'
                }
            }, {
                path: 'systemsettingsub/inportandexportsub/exportcustomer',
                name: 'exportcustomer',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/inportandexportsub/exportcustomer'),
                meta: {
                    title: '导出客户数据'
                }
            }, {
                path: 'systemsettingsub/inportandexportsub/exportcussalestatics',
                name: 'exportcussalestatics',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/inportandexportsub/exportcussalestatics'),
                meta: {
                    title: '导出客户销售数据'
                }
            }, {
                path: 'systemsettingsub/inportandexportsub/exportcussalestaticsorder',
                name: 'exportcussalestaticsorder',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/inportandexportsub/exportcussalestaticsorder'),
                meta: {
                    title: '导出客户销售排行数据'
                }
            }, {
                path: 'systemsettingsub/inportandexportsub/exportgoodsalestaticsorder',
                name: 'exportgoodsalestaticsorder',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/inportandexportsub/exportgoodsalestaticsorder'),
                meta: {
                    title: '导出商品销售排行数据'
                }
            }, {
                path: 'systemsettingsub/inportandexportsub/exportgoodsaledetail',
                name: 'exportgoodsaledetail',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/inportandexportsub/exportgoodsaledetail'),
                meta: {
                    title: '导出销售明细数据'
                }
            }, {
                path: 'systemsettingsub/inportandexportsub/exportinstocksaledetail',
                name: 'exportinstocksaledetail',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/inportandexportsub/exportinstocksaledetail'),
                meta: {
                    title: '导出进货明细数据'
                }
            },{
                path: 'systemsettingsub/inportandexportsub/getgoodinstocksstaticsdata',
                name: 'getgoodinstocksstaticsdata',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/inportandexportsub/getgoodinstocksstaticsdata'),
                meta: {
                    title: '导出商品进货清单数据'
                }
            },{
                path: 'systemsettingsub/batchgoodsub/batchmodgoodsprice',
                name: 'batchmodgoodsprice',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/batchgoodsub/batchmodgoodsprice'),
                meta: {
                    title: '批量修改商品售价'
                }
            }, {
                path: 'systemsettingsub/batchgoodsub/batchmodgoodsorder',
                name: 'batchmodgoodsorder',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/batchgoodsub/batchmodgoodsorder'),
                meta: {
                    title: '批量修改商品排序'
                }
            }, {
                path: 'systemsettingsub/batchgoodsub/batchmodgoodscatalog',
                name: 'batchmodgoodscatalog',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/batchgoodsub/batchmodgoodscatalog'),
                meta: {
                    title: '批量修改商品分类'
                }
            }, {
                path: 'systemsettingsub/batchgoodsub/batchmodgoodsinprice',
                name: 'batchmodgoodsinprice',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/batchgoodsub/batchmodgoodsinprice'),
                meta: {
                    title: '批量修改商品进价'
                }
            }, {
                path: 'systemsettingsub/batchgoodsub/batchdelgoods',
                name: 'batchdelgoods',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/batchgoodsub/batchdelgoods'),
                meta: {
                    title: '批量删除商品到回收站'
                }
            }, {
                path: 'systemsettingsub/batchgoodsub/batchdelgoodsgone',
                name: 'batchdelgoodsgone',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/batchgoodsub/batchdelgoodsgone'),
                meta: {
                    title: '批量彻底删除商品'
                }
            }, {
                path: 'systemsettingsub/batchgoodsub/batchmodgoodsstock',
                name: 'batchmodgoodsstock',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/batchgoodsub/batchmodgoodsstock'),
                meta: {
                    title: '批量修改商品库存'
                }
            },{
                path: 'systemsettingsub/batchgoodsub/batchmodcusorder',
                name: 'batchmodcusorder',
                component: () =>
                    import ('@/views/MassHome/systemsettingsub/batchgoodsub/batchmodcusorder'),
                meta: {
                    title: '批量修改客户排序'
                }
            }
            ,{
                path: 'receiptlist',
                name: 'receiptlist',
                component: () =>
                    import ('@/views/MassHome/receiptlist'),
                meta: {
                    title: '收款单'
                }
            }, {
                path: 'paymentlist',
                name: 'paymentlist',
                component: () =>
                    import ('@/views/MassHome/paymentlist'),
                meta: {
                    title: '收款单'
                }
            }
        ]
    }, {
        path: '/Login',
        name: 'login',
        component: () =>
            import ('@/views/Login/index'),
        meta: {
            title: '微商进销存管理登陆'
        },
    }, {
        path: '*', //必须在routes数组最后一个才能生效
        component: () =>
            import ('@/views/Error-page/404')
    }],
    //滚动行为
    scrollBehavior: () => ({
        x: 0,
        y: 0
    })
})
export default router